import { render } from "./EscalationTable.vue?vue&type=template&id=6f84722e&scoped=true"
import script from "./EscalationTable.vue?vue&type=script&lang=js"
export * from "./EscalationTable.vue?vue&type=script&lang=js"

import "./EscalationTable.vue?vue&type=style&index=0&id=6f84722e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/@vue+cli-service@5.0.9_@vue+compiler-sfc@3.5.26_lodash@4.17.21_sass-loader@13.3.3_node-_2efde1b6c902023e3f10239734cd10e2/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f84722e"]])

export default __exports__